import CodeInputProperties from "./CodeInputProperties";
import React, {useEffect, useState} from "react";
import KeyIcon from '@mui/icons-material/Key';
import TextInput from "../../../ui_components/TextInput/TextInput";


const CodeInput: React.FC<CodeInputProperties> = ({
    value,
    required = false,
    placeholder,
    onChange,
    disabled,
    fullWidth = false,
    className = '',
    error
}) => {

    const [code, setCode] = useState(value)

    useEffect(() => {
        setCode(value)
    }, [value]);

    const onCodeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newName = event.target.value
        setCode(newName)
        onChange(newName)
    }

    return (
        <TextInput
            error={error}
            label={`Código ${required ? '*' : ''}`}
            value={code}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onCodeChange}
            startIcon={KeyIcon}
            className={className}
            fullWidth={fullWidth}
            maxLength={15}
            removeSpaces={true}/>
    )
}
export default CodeInput